import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import TextField from 'material-ui/TextField'
import Menu, {MenuItem} from 'material-ui/Menu'
import {LoadingIndicator} from '../../../components'

const styles = theme => ({
  textField: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,.05)',
    }
  }
})

class SimpleSelector extends React.PureComponent {

  static propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
      disabled: PropTypes.bool,
    })),
    value: PropTypes.any,
    onSelect: PropTypes.func,
    onCancel: PropTypes.func,
    title: PropTypes.string,
    defaultLabel: PropTypes.string,
    disabled: PropTypes.bool,
    isLoading: PropTypes.bool,
  }

  static defaultProps = {
    options: [],
    value: '',
    onSelect: () => {},
    onCancel: () => {},
    title: 'Seleccionado',
    defaultLabel: '',
    disabled: false,
    isLoading: false,
  }

  constructor(props) {
    super(props)

    this.state = {
      open: false,
      anchorEl: null,
      label: props.defaultLabel,
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    // if (nextProps.value !== this.props.value) { TODO should also check if options changed for this to work
    const option = nextProps.options.find(i => i.value === nextProps.value)
    if (option) {
      if (option.label !== this.state.label) this.setLabel(option.label)
    } else {
      this.setLabel(this.props.defaultLabel)
    }
    // }
  }

  setLabel = (label) => {
    this.setState({label})
  }

  setOpen = (open) => this.setState({open})

  handleClick = (e) => {
    if (this.props.disabled === true) return
    this.setState({
      anchorEl: e.currentTarget,
      open: true,
    })
  }

  render() {
    const {classes, title, options, value, onSelect, defaultLabel, isLoading, disabled, error, ...props} = this.props
    const {label, anchorEl} = this.state
    return (
      <div {...props}>
        <LoadingIndicator show={isLoading} noBackDrop={true}>
          <TextField
            label={title}
            fullWidth
            value={label}
            disabled={true}
            onClick={this.handleClick}
            style={{opacity: isLoading || disabled ? .5 : 1}}
            inputProps={{
              className: classes.textField
            }}
            error={error}
          />
          <div>
            <Menu
              anchorEl={anchorEl}
              open={this.state.open}
              onClose={() => this.setOpen(false)}
            >
              {options.map(o => (
                <MenuItem
                  key={o.value}
                  disabled={o.disabled}
                  selected={o.value === value}
                  onClick={() => {
                    this.setOpen(false)
                    onSelect(o.value)
                  }}
                  style={{minWidth: 200}}
                >
                  {o.label}
                </MenuItem>
              ))}
            </Menu>
          </div>
        </LoadingIndicator>
      </div>
    )
  }

}

export default withStyles(styles, {withTheme: true})(SimpleSelector)



// WEBPACK FOOTER //
// ./src/sections/flow/components/simpleSelector.jsx